export const REGEX = Object.freeze({
  UNDERSCORE: /_/g,
  UNDERSCORE_OR_DOT: /[_.]/g,
  NEWLINE: /\r?\n/g,
  ESCAPED_NEWLINE: /\\n/g,
  PIPE: /\|/g
} as const)
